import React from 'react';
import { FormFeedback } from '@tesla/design-system-react';

/**
 * @param {Object} props
 * @param {Boolean} [props.$showError]
 * @param {String} [props.id]
 * @param {React.ReactNode} [props.error]
 * @param {React.ReactNode} [props.feedback]
 * @param {React.ReactNode} [props.helper]
 */
var FeedBack = function FeedBack(_ref) {
  var error = _ref.error,
    showError = _ref.showError,
    feedback = _ref.feedback,
    helper = _ref.helper,
    id = _ref.id;
  if (showError) {
    return /*#__PURE__*/React.createElement(FormFeedback, {
      role: "alert",
      feedbackText: error,
      helperText: helper,
      id: id
    });
  }
  if (feedback || helper) {
    return /*#__PURE__*/React.createElement(FormFeedback, {
      role: "polite",
      feedbackText: feedback,
      helperText: helper,
      id: id
    });
  }
  return null;
};

export { FeedBack };
